(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3583],{

/***/ 23583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content007": function() { return /* binding */ Content007; },
  "default": function() { return /* binding */ Content007_Content007; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.Provider.js
var Tabs_Provider = __webpack_require__(11742);
// EXTERNAL MODULE: ./src/components/widgets/content/Content007/Content007.module.scss
var Content007_module = __webpack_require__(45866);
var Content007_module_default = /*#__PURE__*/__webpack_require__.n(Content007_module);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.hooks.js
var Tabs_hooks = __webpack_require__(60419);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content007/Documents/Documents.jsx





var Documents = function(param) {
    var documents = param.documents, attachments = param.attachments;
    var activeTab = (0,Tabs_hooks/* useTabsState */.n)().activeTab;
    var filterByCourseSlug = (0,react.useCallback)(function(param) {
        var course = param.course;
        return (course === null || course === void 0 ? void 0 : course.title) === activeTab;
    }, [
        activeTab
    ]);
    var filteredAttachments = (0,react.useMemo)(function() {
        return attachments.filter(filterByCourseSlug);
    }, [
        attachments,
        filterByCourseSlug
    ]);
    var filteredDocuments = (0,react.useMemo)(function() {
        return documents.filter(filterByCourseSlug);
    }, [
        documents,
        filterByCourseSlug
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Content007_module_default()).documents,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* StickableContent */.cV, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* AttachmentsList */.Fy, {
                    items: filteredAttachments
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Content007_module_default()).list,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* OrderedList */.GS, {
                    items: filteredDocuments,
                    appearance: "small"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content007/Documents/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content007/Content007.jsx









var Content007 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var areTabsEnabled = (ref1 = payload === null || payload === void 0 ? void 0 : payload.showTab) !== null && ref1 !== void 0 ? ref1 : true;
    var ref2;
    var documents = (0,react.useMemo)(function() {
        return (ref2 = payload === null || payload === void 0 ? void 0 : payload.documentList) !== null && ref2 !== void 0 ? ref2 : [];
    }, [
        payload
    ]);
    var ref3;
    var attachments = (0,react.useMemo)(function() {
        return (ref3 = payload === null || payload === void 0 ? void 0 : payload.documentAttachments) !== null && ref3 !== void 0 ? ref3 : [];
    }, [
        payload
    ]);
    var extractedTabs = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(new Set(documents.map(function(item) {
            return item.course.title;
        })));
    }, [
        documents
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content007_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs_Provider/* TabsProvider */.X, {
            items: extractedTabs,
            tabsEnabled: areTabsEnabled,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                    className: (Content007_module_default()).inner,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Content007_module_default()).top,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((Content007_module_default()).header, (0,_define_property/* default */.Z)({}, (Content007_module_default())["header-margin"], areTabsEnabled)),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                                    as: "h3",
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Tabs */.mQ, {
                                appearance: "justify"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Content007_module_default()).content,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                        className: (Content007_module_default()).inner,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Documents, {
                            attachments: attachments,
                            documents: documents
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Content007_Content007 = (Content007);


/***/ }),

/***/ 45866:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content007_wrapper__T6Acf","top":"Content007_top__FhxVN","header":"Content007_header__WKfDe","content":"Content007_content__mB9K_","documents":"Content007_documents__wAYD1","list":"Content007_list__hXQEv","header-margin":"Content007_header-margin__9r3VG"};

/***/ })

}]);